import { Bell, Shield, Eye, MessageCircle, Clock } from "lucide-react";
import { useState, useEffect } from "react";
import { Pagination, Spin, Modal } from "antd"; // Import Modal from Ant Design
import { getData } from "../../api/api"; // Assuming the getData function is defined in the api file
import { useNavigate } from 'react-router-dom';

export default function Notifications() {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]); // Lưu trữ danh sách thông báo
  const [loading, setLoading] = useState(true); // Quản lý trạng thái đang tải
  const [page, setPage] = useState(1); // Quản lý số trang hiện tại
  const [total, setTotal] = useState(0); // Tổng số thông báo
  const [selectedNotification, setSelectedNotification] = useState(null); // Thông báo được chọn để xem chi tiết
  const [isModalVisible, setIsModalVisible] = useState(false); // Quản lý trạng thái hiển thị modal

  // Hook useEffect để fetch dữ liệu từ API
  useEffect(() => {
    setLoading(true);
    getData(`/notifications?pageNumber=${page - 1}&pageSize=5`) // Gọi API với phân trang
      .then((res) => {
        setNotifications(res.data.data); // Cập nhật danh sách thông báo
        setTotal(res.data.pagination.totalRow); // Cập nhật tổng số thông báo
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [page]); // Chạy lại effect khi page thay đổi

  // Hàm hiển thị chi tiết thông báo trong modal
  const showNotificationDetail = (notification) => {
    setSelectedNotification(notification); // Lưu thông báo được chọn
    setIsModalVisible(true); // Hiển thị modal
  };

  // Hàm đóng modal
  const handleCancel = () => {
    setIsModalVisible(false); // Ẩn modal
    setSelectedNotification(null); // Xóa thông báo đang chọn
  };

  return (
    <div className="max-w-xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-4">
      <div className="p-4 border-b">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">Notifications</h2>
          {/* <button className="text-gray-500 hover:text-gray-700">
            <span className="sr-only">More options</span>
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
          </button> */}
        </div>
        <div className="mt-1 text-sm text-gray-500">Previous</div>
      </div>

      <div className="divide-y">
        {/* Show Spin while loading */}
        {loading ? (
          <div className="flex justify-center py-4">
            <Spin size="large" />
          </div>
        ) : (
          <>
            {notifications.length === 0 && (
              <p className="text-center p-10 text-2xl">No notifications yet</p>
            )}
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className="p-4 hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => showNotificationDetail(notification)} // Open detail on click
              >
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    {/* Notification icon, can be customized based on notification type */}
                    <Bell className="w-5 h-5 text-blue-500" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm text-gray-900">
                      {notification.title}
                    </h3>
                    <div className="mt-1 text-xs text-gray-500">
                      {notification.data.createAt}
                    </div>
                    <div className="mt-2 text-xs text-gray-500">
                      {notification.body}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Pagination component from Ant Design */}
      <div className="p-4">
        <Pagination
          current={page}
          total={total}
          pageSize={5}
          onChange={(pageNumber) => setPage(pageNumber)} // Update page number
          showSizeChanger={false} // Hide option to change items per page
          showTotal={(total) => `Total: ${total} notifications`}
        />
      </div>

      {/* Modal for displaying notification details */}
      <Modal
        title="Notification Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        {selectedNotification && (
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0 mt-1">
                {/* Notification icon can be customized */}
                <Bell className="w-8 h-8 text-blue-500" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-semibold text-gray-900">
                  {selectedNotification.title}
                </h3>
                <div className="text-sm text-gray-500">
                  {selectedNotification.data.createAt}
                </div>
                <div className="mt-3 text-sm text-gray-700">
                  {selectedNotification.body}
                </div>

                {/* Link, type, and read status */}
                <div className="mt-4 text-xs text-gray-500">
                  <p>
                    <strong>Link:</strong>{" "}
                    <span 
                      className="text-blue-500 cursor-pointer hover:underline"
                      onClick={() => {
                        navigate(`/Forums/${selectedNotification.data.link}`);
                        setIsModalVisible(false);
                      }}
                    >
                      {`/Forums/${selectedNotification.data.link}`}
                    </span>
                  </p>
                  <p>
                    <strong>Type:</strong> {selectedNotification.data.type}
                  </p>
                  {/* <p>
                    <strong>Read Status:</strong>{" "}
                    {selectedNotification.data.isRead ? "Read" : "Unread"}
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
